import { render, staticRenderFns } from "./vipGift.vue?vue&type=template&id=0f49329f&scoped=true&"
import script from "./vipGift.vue?vue&type=script&lang=js&"
export * from "./vipGift.vue?vue&type=script&lang=js&"
import style0 from "./vipGift.vue?vue&type=style&index=0&id=0f49329f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f49329f",
  null
  
)

export default component.exports